import { select, takeLatest } from 'redux-saga/effects';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import { Map, fromJS } from 'immutable';
import FabricUtils from '../utils/FabricUtils';
import {
  projectImagesSelector,
  editorDimSelector,
} from '../reducers/selectors';

export const SET_IMAGES_TO_PRELOAD = 'SET_IMAGES_TO_PRELOAD';

/**
 *  reducers
 */
function preloader(state = new Map(), action) {
  switch (action.type) {
    case SET_IMAGES_TO_PRELOAD:
      return fromJS(action.images);
  }

  return state;
}

/**
 *  actions
 */
export function setImagesToPreload(images) {
  return {
    type: SET_IMAGES_TO_PRELOAD,
    images,
  };
}

function* setProjectSaga(action) {
  let images = yield select(projectImagesSelector);
  let editorDim = yield select(editorDimSelector);

  if (action.project.imagesToCache) {
    setTimeout(() => {
      action.project.imagesToCache.forEach((imageData) => {
        let image = images.get(imageData.id);
        let url = image.get('workPath');
        if (
          image.get('highResPath') &&
          (imageData.width * editorDim.ratioWidth > 600 ||
            imageData.height * editorDim.ratioWidth > 600)
        ) {
          url = image.get('highResPath');
        }
        let fabricURL = FabricUtils.fabricImageURL(url);
        var preloadLink = document.createElement('link');
        preloadLink.href = fabricURL;
        preloadLink.rel = 'preload';
        preloadLink.importance = 'low';
        preloadLink.as = 'image';
        preloadLink.crossOrigin = 'anonymous';
        document.head.appendChild(preloadLink);
      });
    }, 10000);
  }

  // yield put(setImagesToPreload(action.project.imagesToCache));
}

function* setupSagas() {
  yield takeLatest([SET_PROJECT, SET_PROJECT_UNDOABLE], setProjectSaga);
}

export default {
  reducer: preloader,
  saga: setupSagas,
};
